import { render, staticRenderFns } from "./AwardCertificatePopup.vue?vue&type=template&id=06fcae32&"
import script from "./AwardCertificatePopup.vue?vue&type=script&lang=js&"
export * from "./AwardCertificatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports